module.exports = __webpack_public_path__ + "img/logo-branco-drogasil.e01418c4.svg";